import TitleBlock from '@anm/components/TitleBlock';
import { media } from '@anm/styles/helpers';
import styled, { css } from 'styled-components';

const protectedVideoWrapperMobile = media.phone`
    padding-bottom: 100%;
`;

export const Wrapper = styled.div<{ color: string }>`
  width: 100%;
  padding-bottom: 56.25%;
  background: ${({ color }) => color};
  position: relative;
  ${protectedVideoWrapperMobile};
`;

export const Container = styled.div`
  width: 100%;
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const FormWrapper = styled.div`
  width: 300px;
  padding: 10px;
  border-radius: 5px;
  text-align: center;
  color: #fff;
`;

export const PasswordForm = styled.form`
  width: 160px;
  margin: 17px auto 0;
  background: #fff;
  position: relative;
  border-radius: 5px;
  padding: 0 30px 0 10px;
`;

const disabledButton = css`
  cursor: default;
  pointer-events: none;
`;

const getButtonStyles = (disabled = false) => {
  const color = disabled ? `#EBEEF5` : '#919eaa';

  return css`
    border-top: 2px solid ${color};
    border-right: 2px solid ${color};
    ${disabled && disabledButton};

    &:after {
      background: ${color};
    }
  `;
};

export const SubmitButton = styled.button<{ disabled?: boolean }>`
  width: 12px;
  height: 12px;
  opacity: 0.5;
  border: 0;
  position: absolute;
  top: 14px;
  right: 12px;
  padding: 0;
  outline: none;
  transform: rotate(45deg);
  cursor: pointer;
  transition: 0.3s;
  background-color: transparent;

  &:after {
    display: block;
    content: '';
    width: 14px;
    transition: 0.3s;
    height: 2px;
    position: absolute;
    top: 4px;
    right: -2px;
    transform: rotate(-45deg);
  }

  ${({ disabled }) => getButtonStyles(disabled)};
`;

const iconActiveStyles = css`
  & + ${SubmitButton} {
    opacity: 1;
  }
`;

export const InputField = styled.input<{ isIconActive: boolean }>`
  display: block;
  background: transparent;
  height: 40px;
  width: 100%;
  flex-grow: 1;
  box-sizing: border-box;
  font-size: 16px;
  line-height: 19px;
  outline: none;
  border: none;
  color: #292a2b;
  ${({ isIconActive }) => isIconActive && iconActiveStyles}
`;

export const FormTitle = styled(TitleBlock)`
  h1,
  h2,
  h3,
  h4,
  h5,
  h6 {
    color: #fff;
    font-size: 20px;
    line-height: 28px;
    font-family: 'Inter', sans-serif;
  }
`;

export const SubmitError = styled.p<{ showError: boolean }>`
  line-height: 18px;
  margin-top: 8px;
  font-size: 14px;
  color: #fff;
  margin-top: 8px;
  opacity: ${({ showError }) => (showError ? 1 : 0)};
`;
